import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "view-post mb-20 md:mb-44"
}
const _hoisted_2 = { class: "relative my-10 md:my-0 flex flex-col md:block" }
const _hoisted_3 = { class: "\n            grid grid-cols-1\n            md:grid-cols-2\n            md:absolute\n            right-0\n            left-0\n            order-2\n          " }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_5 = { class: "relative fill-post-image" }
const _hoisted_6 = { class: "relative md:absolute left-0 right-0 order-1" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 max-w-container px-container" }
const _hoisted_8 = { class: "flex flex-col justify-center" }
const _hoisted_9 = { class: "text-2xl md:text-4xl font-bold leading-tight" }
const _hoisted_10 = { class: "text-sm sm:text-md md:text-lg mt-3 mb-6" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "fill-post-image hidden md:block" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "hidden md:grid grid-cols-2 mb-20" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div", { class: "relative fill-post-image" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostSkeleton = _resolveComponent("PostSkeleton")
  const _component_ShareButton = _resolveComponent("ShareButton")
  const _component_ShareModal = _resolveComponent("ShareModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!_ctx.post)
          ? (_openBlock(), _createBlock(_component_PostSkeleton, { key: 0 }))
          : (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode("div", _hoisted_5, [
                    _createVNode("img", {
                      src: _ctx.image,
                      class: ["\n                w-full\n                h-full\n                object-cover\n                absolute\n                transition\n                duration-200\n                ease-in-out\n              ", { 'opacity-0': !_ctx.showImage }],
                      onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showImage = true))
                    }, null, 42, ["src"])
                  ])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.post.title), 1),
                      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.post.publishDateFormated), 1),
                      _createVNode(_component_ShareButton, {
                        class: "mr-auto",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShareModalOpen = true))
                      })
                    ]),
                    _hoisted_11
                  ])
                ])
              ]),
              _hoisted_12,
              _createVNode("div", {
                class: "px-container relative mx-auto max-w-3xl",
                innerHTML: _ctx.post.content
              }, null, 8, ["innerHTML"]),
              (_ctx.jsonld)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                    key: 0,
                    type: "application/ld+json",
                    innerHTML: _ctx.jsonld
                  }, null, 8, ["innerHTML"]))
                : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    }),
    (_ctx.isShareModalOpen)
      ? (_openBlock(), _createBlock(_component_ShareModal, {
          key: 0,
          isShareModalOpen: _ctx.isShareModalOpen,
          "onUpdate:isShareModalOpen": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShareModalOpen = $event)),
          title: _ctx.post.title,
          image: _ctx.image
        }, null, 8, ["isShareModalOpen", "title", "image"]))
      : _createCommentVNode("", true)
  ], 64))
}